import { render, staticRenderFns } from "./subscriptionPlan.vue?vue&type=template&id=65214443&scoped=true"
import script from "./subscriptionPlan.vue?vue&type=script&lang=js"
export * from "./subscriptionPlan.vue?vue&type=script&lang=js"
import style0 from "./subscriptionPlan.vue?vue&type=style&index=0&id=65214443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65214443",
  null
  
)

export default component.exports